import { render, staticRenderFns } from "./SemanaEpidemiologicaLista.vue?vue&type=template&id=7aea1679&"
import script from "./SemanaEpidemiologicaLista.vue?vue&type=script&lang=js&"
export * from "./SemanaEpidemiologicaLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports